@if (!isBusy) {
<span class="flex items-center justify-center">
  @if (iconLeft) {
  <pax-icon class="mr-3" [name]="iconLeft" containerClass="w-5 h-5"></pax-icon>
  }
  <ng-content></ng-content>

  @if (iconRight) {
  <pax-icon class="ml-3" [name]="iconRight" containerClass="w-5 h-5"></pax-icon>
  }
</span>

} @else {
<div
  class="absolute left-0 top-0 flex h-full w-full items-center justify-center"
>
  @switch(variant){ @case("primary"){
  <pax-spinner variant="white"></pax-spinner>
  } @case("primary-outlined"){
  <pax-spinner variant="primary"></pax-spinner>
  } @default {
  <pax-spinner variant="white"></pax-spinner>
  }}
</div>
}
